import type { SchemaInput } from './schema-input.js';
import { isNumber, isSchemaRecord } from './runtime-values.js';

export interface GeographicPoint { lat: number; lng: number }

export function parseGeographicPoint(value: SchemaInput): GeographicPoint | null {
  if (!isSchemaRecord(value) || !isNumber(value.lat) || !isNumber(value.lng)
    || !Number.isFinite(value.lat) || !Number.isFinite(value.lng)
    || Math.abs(value.lat) > 90 || Math.abs(value.lng) > 180) return null;
  return { lat: value.lat, lng: value.lng };
}
